import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchEphemeralUsers = (setEphemeralUsers: Function, setLoaded: Function, language: string) => {
  setLoaded(false);

  ApiService.get("ephemeral-evaluations/users")
    .then((resp) => setEphemeralUsers(resp.data.ephemeral_evaluations_users))
    .catch((err) => {
      console.error("Error fetching ephemeral evaluations users:", err);
      alert(translate(language, "PAGES.EPHEMERAL_USERS.ERRORS.FETCH"));
    })
    .finally(() => setLoaded(true));
};
